import commonEvents from './commonEvents'
import loginEvents from './login'
import idvEvents from './idverification'
import subscriptionEvents from './subscription'
import paymentEvents from './payment'
import declinedEvents from './declinedOrder'
import financeEvents from './finance'

export const TRACKING_EVENTS = {
  ...commonEvents,
  ...loginEvents,
  ...idvEvents,
  ...subscriptionEvents,
  ...paymentEvents,
  ...declinedEvents,
  ...financeEvents,
}

export const UQUDO_IDV_PREFIX = 'idverification_uae__uqudo'

export const DEFAULT_DATA_PARAMS = [
  'order_id',
  'session_id',
  'user_id',
  'merchant_id',
  'merchant_name',
  'language',
  'order_country_code',
  'order_total_amount',
  'currency_code',
  'checkout_variation',
  'mobile_number',
  'checkout_step',
  'id_verified',
  'equal_installment',
  'payment_type',
  'user_type',
  'apple_pay_preference',
  'apple_pay_preference_from_cards_v2',
  'is_pcidss_enabled',
  'is_pcidss_apple_pay_enabled',
  'product_flow',
  'is_embedded',
]
